<template>
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.9988 13.2787L10.3455 8.93208C10.8588 8.41875 10.8588 7.57875 10.3455 7.06542L5.9988 2.71875" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>